import { render, staticRenderFns } from "./ImportArticle.vue?vue&type=template&id=45095c32&scoped=true"
import script from "./ImportArticle.vue?vue&type=script&lang=js"
export * from "./ImportArticle.vue?vue&type=script&lang=js"
import style0 from "./ImportArticle.vue?vue&type=style&index=0&id=45095c32&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45095c32",
  null
  
)

export default component.exports